import React from "react";

export default function Terms() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-4">Terms &amp; Conditions</h1>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Use of Service</h2>
      <p className="text-slate-800 leading-7">
        Treble Town provides online music-learning content for personal, non-commercial use.
        Sharing login access is not permitted.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Payments</h2>
      <p className="text-slate-800 leading-7">
        Payments are processed securely by a third-party payment gateway. Access is granted once
        payment is successful.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Content &amp; IP</h2>
      <p className="text-slate-800 leading-7">
        All content, lessons, and materials are owned by Treble Town / Nishat Chadha.
        Unauthorized copying or distribution is prohibited.
      </p>

      <h2 className="text-2xl font-semibold mt-4 mb-2">Contact</h2>
      <p className="text-slate-800 leading-7">
        Email: <a className="text-sky-600 hover:underline" href="mailto:nishatchadha@gmail.com">nishatchadha@gmail.com</a> •
        Phone: <a className="text-sky-600 hover:underline" href="tel:+919833255196">+91 98332 55196</a>
      </p>
    </div>
  );
}
